import L from 'leaflet';

const POSITION_TOLERANCE = 0.00005;

const isCloseCoordinate = (a, b) => Math.abs(a - b) <= POSITION_TOLERANCE;

export const findInterestPointIndexByLatLng = (
  latLng,
  interestPoints = [],
) => {
  if (!latLng) return -1;

  return (interestPoints || []).findIndex(point => {
    if (!point) return false;

    return (
      isCloseCoordinate(point.lat, latLng.lat) &&
      isCloseCoordinate(point.lng, latLng.lng)
    );
  });
};

export const createIntermediateWaypointIcon = () =>
  L.divIcon({
    html: `
      <div style="
        background: linear-gradient(135deg, #6c757d 0%, #868e96 100%);
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border: 2px solid #ffffff;
        box-shadow: 0 2px 7px rgba(0, 0, 0, 0.35);
        display: flex;
        align-items: center;
        justify-content: center;
      ">
        <span style="
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #ffffff;
        "></span>
      </div>
    `,
    className: '',
    iconSize: [22, 22],
    iconAnchor: [11, 11],
    popupAnchor: [0, -16],
  });

export const bindIntermediateWaypointRemoval = ({
  marker,
  onRemove,
}) => {
  if (!marker || typeof onRemove !== 'function') return;

  const removeButtonId = `remove-via-${Math.random().toString(36).slice(2, 10)}`;

  marker.bindPopup(
    `<button id="${removeButtonId}" type="button" style="background:#dc3545;color:#fff;border:none;border-radius:4px;padding:6px 10px;cursor:pointer;font-size:13px;font-weight:600;">Remover ponto de passagem</button>`,
    { closeButton: false },
  );

  marker.on('popupopen', () => {
    const removeButton = document.getElementById(removeButtonId);
    if (!removeButton) return;

    removeButton.onclick = () => {
      onRemove();
      marker.closePopup();
    };
  });
};
